import { client } from '../client';
import { Address, UserProfile } from './types/UserProfile';

export type CreateUserPayload = {
  email?: string;
  address?: Address;
  phone_number?: string;
  type?: string;
  organization_ids?: string[];
  division_ids?: string[];
  practice_ids?: string[];
  send_invitation?: boolean;
  full_name?: string;
  frontend_website?: string;
  is_quick_add?: boolean;
  client_ids?: number[];
};

export type CreateNewUserOptions = {
  useSuperAdminEndpoint?: boolean;
};

/** When both are non-empty after trim, returns `"First Last"` for `createNewUser` payloads. */
export function fullNameFromFirstAndLast(
  firstName: string | undefined | null,
  lastName: string | undefined | null,
): string | undefined {
  const first = String(firstName ?? '').trim();
  const last = String(lastName ?? '').trim();
  if (!first || !last) return undefined;
  return `${first} ${last}`;
}

export const createNewUser = async (
  payload: CreateUserPayload,
  options?: CreateNewUserOptions,
): Promise<UserProfile> => {
  const path = options?.useSuperAdminEndpoint ? '/superadmin/users' : '/admin/users';
  const { data } = await client.post<UserProfile>(path, payload);

  return data;
};
